import { Component, inject, Input, OnInit } from '@angular/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../manager/edro-network-manager';
import {
  IonButton,
  IonContent,
  ModalController,
} from '@ionic/angular/standalone';
import { Pool, PoolAdditionalData } from '../../../../../../../apis/pool.api';
import { IProduct } from '../../../../IProduct';
import { TwoChoicesModalComponent } from '../../../../../../../components/ecosystems/two-choices-modal/two-choices-modal.component';
import { HeaderConfigurationComponent } from '../../../../../../../components/ecosystems/header-configuration/header-configuration.component';
import { InformationTitleComponent } from '../../../../../../../components/ecosystems/information-title/information-title.component';
import { LabelDescriptionComponent } from '../../../../../../../components/ecosystems/label-description/label-description.component';
import { LargedLinkComponent } from '../../../../../../../components/ecosystems/larged-link/larged-link.component';
import { TranslatePipe } from '@ngx-translate/core';
import { P00080PositionTypeEnum } from '../../Enum/P00080PositionTypeEnum';
import { P00039DataRxTxIndex } from '../../../P00039Sync';

@Component({
  selector: 'app-p00080-installation-position',
  templateUrl: './p00080-installation-position.component.html',
  styleUrls: ['./p00080-installation-position.component.scss'],
  imports: [
    HeaderConfigurationComponent,
    InformationTitleComponent,
    IonButton,
    IonContent,
    LabelDescriptionComponent,
    LargedLinkComponent,
    TranslatePipe,
  ],
})
export class P00080InstallationPositionComponent implements OnInit {
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  private modalController: ModalController = inject(ModalController);
  @Input() prev: () => void = () => {};
  @Input() next: (
    actionStack: DeviceActionStackService,
    poolAdditionalData: PoolAdditionalData,
  ) => void = () => {};

  @Input() productClass: IProduct | null = null;

  @Input() pool: Pool | null = null;

  @Input() poolAdditionalData: PoolAdditionalData | null = null;

  @Input() actionStackParam: any | null = null;
  actionStack: DeviceActionStackService | null = null;

  alPositionInjection: number | undefined = undefined;

  constructor() {}

  async openPositionModal() {
    const modal = await this.modalController.create({
      component: TwoChoicesModalComponent,
      componentProps: {
        title: 'P00080.modal.positiontype.title',
        value: this.alPositionInjection,
        firstChoice: {
          title: 'P00080.modal.positiontype.option0',
          image:
            '/assets/ecosystem/images/products/P00080/P00080-position-0-black.png',
          value: 0,
        },
        secondChoice: {
          title: 'P00080.modal.positiontype.option1',
          image:
            '/assets/ecosystem/images/products/P00080/P00080-position-1-black.png',
          value: 1,
        },
      },
      cssClass: 'dynamic-height',
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      this.alPositionInjection = data.value;
    }
  }

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      this.actionStackParam,
    );

    this.alPositionInjection =
      this.poolAdditionalData?.alPositionInjection ?? 0;
  }

  onSubmit() {
    this.poolAdditionalData!.alPositionInjection = this.alPositionInjection!;
    this.next(this.actionStack!, this.poolAdditionalData!);
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly P00080PositionTypeEnum = P00080PositionTypeEnum;
}
